import { Category } from 'types/entity/category';

/**
 * Sorts category groups by priority and alphabetically
 * @param categories Array of categories
 * @returns Sorted array of unique groups
 */
export const sortCategoryGroups = (categories: Category[]): string[] => {
  const arr = [...new Set(categories.map((x) => x.customGroup || ''))];
  const priority = ['typology', 'family', 'material'];

  return [...arr].sort((a, b) => {
    const indexA = priority.indexOf(a);
    const indexB = priority.indexOf(b);

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    return a.localeCompare(b);
  });
};
